import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Autocomplete,
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Typography,
} from "@mui/material";

import {
    getPlantList,
    addPlant,
    updatePlant,
    deletePlant
} from "../../store/actions/PlantActions";

import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function Plant() {
    const { t } = useTranslation("translation");

    const dispatch = useDispatch();
    const { plant } = useSelector(
        (plant) => plant
    );

    const [pageLoaded, setPageLoaded] = useState(false);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");

    const [isAddDisable, setIsAddDisable] = useState(true);

    //tabloyla alakali stateler
    const [plantList, setPlantList] = useState([]);

    //Sayfanin ilk acilmasiyla alakali stateler
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
 
    useEffect(() => {
        loadHandler();
    }, []);


    useEffect(() => {
        if (plant?.plantList?.resultObject?.length) {
            setInitialRows(plant.plantList.resultObject);
            setRows(plant.plantList.resultObject);
            plant.plantList = {};
            setPageLoaded(true);
        }
        if (plant.isTaskUpdatedPlant) {
            setEditableRow(false);
            setDisableButton(false);
            loadHandler();
        }
    }, [plant]);

    const loadHandler = () => {
        dispatch(getPlantList());
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item) => {
            if (item.id === "Actions") {
                return <TableCell align="center">{t("Actions")}</TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell align="center">
                        <TableSortLabel
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() =>
                                handleSort(cloneObject(initialRows), item.id)
                            }
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

     //dynamic sort function
     let [sortOrder, setSortOrder] = useState();
     let [sortColumn, setSortColumn] = useState();

     const handleSort = (row, column) => {
         const sortedList = commonSort(row, column);
         setSortOrder(sortedList[0]);
         setSortColumn(sortedList[1]);
         setInitialRows(sortedList[2]);
         setRows(sortedList[2]);
     };

     const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

     // Pagination
     const [currentPage, setCurrentPage] = useState(0);
     const [rowsPerPage, setRowsPerPage] = useState(20);
     const handleChangePage = (_event, newPage) => {
         setCurrentPage(newPage);
     };
 
     const handleChangeRowsPerPage = (event) => {
         setRowsPerPage(+event.target.value);
         setCurrentPage(0);
     };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
        if (value.length > 0) {
            if (obj === "code") {
                setError({ ...error, plantCodeError: "" });
            } else if (obj === "name") {
                setError({ ...error, plantNameError: "" });
            }else if (obj === "company") {
                setError({ ...error, plantCompanyError: "" });
            }else if (obj === "sapCode") {
                setError({ ...error, plantSAPError: "" });
            }
            
        } else {
            if (obj === "code") {
                setError({ ...error, plantCodeError: t("PlantCodeValidation") });
            } else if (obj === "name") {
                setError({ ...error, plantNameError: t("PlantNameValidation") });
            }else if (obj === "company") {
                setError({ ...error, plantCompanyError: t("PlantCompanyValidation") });
            }else if (obj === "sapCode") {
                setError({ ...error, plantSAPError: t("PlantSAPCodeValidation") });
            }
        }

    };

    const updateAddHandler = (row) => {
        // update
        if (row.id !== "") {
            const data = {
                ID: row.id,
                Company: row.company,
                Code: row.code,
                Name: row.name,
                SapCode: row.sapCode,
                Status: row.status,
            };
            dispatch(updatePlant(data));
        }
        // add
        else {
            const data = {
                Company: row.company,
                Code: row.code,
                Name: row.name,
                SapCode: row.sapCode,
            };
          
            dispatch(addPlant(data));
        }
    };

    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);

        setError({
            plantCodeError: t("PlantCodeValidation"),
            plantNameError: t("PlantNameValidation"),
            plantCompanyError: t("PlantCompanyValidation"),
            plantSAPError: t("PlantSAPCodeValidation"),
        });
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const [disableButton, setDisableButton] = useState(false);

    // Filter table
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.code.toLowerCase().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText) || item.company.toLowerCase().includes(newFilteredText) || item.sapCode.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
        setDisableButton(false);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const enableEditHandler = (row) => {
        if (disableButton || editable) {
            filterData(filterText);
        }
        setDisableButton(true);
        setEditableRow(row.id);
        setEditable(true);

        setError({
            plantCodeError: "",
            plantNameError: "",
            plantCompanyError: "",
            plantSAPError: ""
        });
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setCurrentPage(0);
        setDisableButton(true);
        const  addedBlankRow = [
            {
                id: "",
                company: "",
                code: "",
                name: "",
                sapCode: "",
            },
        ];

        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const deleteHandler = (row) => {
        toggleModal();
        const data = {
            ID: row.id,
            Company: row.company,
            Code: row.code,
            Name: row.name,
            SapCode: row.sapCode,
        };
        dispatch(deletePlant(data));
    };

    const [error, setError] = useState({
        plantCodeError: t("PlantCodeValidation"),
        plantNameError: t("PlantNameValidation"),
        plantCompanyError: t("PlantCompanyValidation"),
        plantSAPError: t("PlantSAPCodeValidation"),
    });

    useEffect(() => {
        if (error.plantCodeError === "" && error.plantNameError === "" && error.plantCompanyError === "" && error.plantSAPError === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);


    return (
        <StyledTableDiv>
        <h1>
            {t("Plant")} {t("List")}{" "}
        </h1>
        <AddButton
            onClick={() => addBlankRowHandler()}
            disabled={disableButton}
        />
        {pageLoaded === true ? (
            <Grid
                container
                spacing={4}
                alignItems="center"
                justifyContent="center"
                sx={{ marginBottom: 4 }}
            >
                <Grid item xs={12} sm={12} md={4}>
                    <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                </Grid>
            </Grid>
        ) : null}
        <Box m={2} />
        {rows.length > 0 ? (
            <Grow
                in={true}
                style={{ transformOrigin: "0 0 0" }}
                {...{ timeout: 1000 }}
            >
                <TableContainer component={Paper}>
                <Table id="gt_Table" aria-label="simple table">
                            <TableHead id="rg_TableHead">
                                <TableRow id="rg_TableRow">
                                    {renderTableCell([
                                            { id: "id", label: t("ID") },
                                            { id: "company", label: t("PlantCompany") },
                                            { id: "code", label: t("PlantCode") },
                                            { id: "name", label: t("PlantName") },
                                            { id: "sapCode", label: t("EquipmentSAPCode") },
                                            { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody id="rg_TableBody">
                                {rows.slice(
                                    currentPage * rowsPerPage,
                                    currentPage * rowsPerPage + rowsPerPage
                                    ).map((row, index) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow key={row.id} id={`p_TableRow_${index}`}>
                                            <TableCell align="center" id={`p_TableCell_${index}`}>
                                                {row.id}
                                            </TableCell>
                                            <TableCell align="center" id={`p_TableCell_1_${index}`}>
                                                {editable && editableRow === row.id && editableRow === "" ? (
                                                    <TextField
                                                        onInput={(e) => setRowHandler(e.target.value, "company", row)}
                                                        defaultValue={row.company}
                                                        variant="outlined"
                                                        error={error.plantCompanyError.length > 0}
                                                        helperText={error.plantCompanyError} 
                                                        FormHelperTextProps ={{id: "p_val1"}}
                                                        id={`p_TextField_${index}`}
                                                    />
                                                ) : (
                                                    row.company
                                                )}
                                            </TableCell>
                                            <TableCell align="center" id={`p_TableCell_2_${index}`}>
                                                {editable && editableRow === row.id && editableRow === "" ? (
                                                    <TextField
                                                        onInput={(e) => setRowHandler(e.target.value, "code", row)}
                                                        defaultValue={row.code}
                                                        variant="outlined"
                                                        error={error.plantCodeError.length > 0}
                                                        helperText={error.plantCodeError} 
                                                        FormHelperTextProps ={{id: "p_val2"}}
                                                        id={`p_TextField_1_${index}`}
                                                    />
                                                ) : (
                                                    row.code
                                                )}
                                            </TableCell>
                                            <TableCell align="center" id={`p_TableCell_3_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        onInput={(e) => setRowHandler(e.target.value, "name", row)}
                                                        defaultValue={row.name}
                                                        variant="outlined"
                                                        error={error.plantNameError.length > 0}
                                                        helperText={error.plantNameError} 
                                                        FormHelperTextProps ={{id: "p_val3"}}
                                                        id={`p_TextField_2_${index}`}
                                                    />
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>
                                            <TableCell align="center" id={`p_TableCell_4_${index}`}>
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        onInput={(e) => setRowHandler(e.target.value, "sapCode", row)}
                                                        defaultValue={row.sapCode}
                                                        variant="outlined"
                                                        error={error.plantSAPError.length > 0}
                                                        helperText={error.plantSAPError} 
                                                        FormHelperTextProps ={{id: "p_val4"}}
                                                        id={`p_TextField_3_${index}`}
                                                    />
                                                ) : (
                                                    row.sapCode
                                                )}
                                            </TableCell>
                                            <TableButtons
                                                editable={editable}
                                                editableRow={editableRow}
                                                row={row}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                                detail={false}
                                                addDisabled={isAddDisable}
                                            />
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>

                    <TablePagination
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Grow>
        ) : null}
        <Modal
            title={t("Delete")}
            content={t("WillYouDoTransaction")}
            approved={() => deleteHandler(deletedRow)}
            isModalOpen={isModalOpen}
            toggle={toggleModal}
        />
        <LoadingBackdrop />
    </StyledTableDiv>
    );
}
